import React, { useContext, useEffect, useState } from 'react';
import {
  ClientDataSearchColumn, ClientDataSearchError, ClientDataButtoCalculate, ClientDataAddButton, ClientDataButtoCalculateButton,
  ClientDataTotal, ClientDataTotalPrice, ClientDataTotalTitle, ClientDataMontoTotal, ClientDataTotalData, ClientDataTotalDataMin,
  ClientDataTotalDataMinBlack, InfoCircleImage, Tooltip, TooltipContent, TooltipTitle
} from './styles';
import { useForm, Controller } from 'react-hook-form';
import { SimulatorContext } from '../../../store';
import { currencyMoney } from '../../../config/currency';
import { getTasas, getTasasFilter, getTasasPricing, getTasasPricingAndCifin, isPricing } from '../../../services/tasas';
import { getPaymentBill } from '../../../services/paymentbill';
import { getStates } from '../../../services/states';
import { handleChangeIdentification } from '../../../helpers/price';
import { default as SimulatorTypes } from '../../../store/Simulator/types';
import Select from '../../../components/Select';
import InputDefault from '../../../components/InputDefault';
import InputIntl from '../../../components/InputIntl';
import RadioButtonForm from '../../../components/RadioButtonForm';
import { simulatorSteps } from '../../../helpers/enum';
import { DefaultSmallButton, SecondaryLargeButton, DefaultSmallButtonBuscar } from '../../../components/Buttons/styles';
import FormTemplate from '../../../components/FormTemplate';
import { Form, FormRow, FormFooter, FormRow3Columns, FormRowInvisible, FormFooterRigth } from '../../../components/FormTemplate/styles';
import Loader from '../../../components/Loader';
import SearchField from '../../../components/SearchField';
import { identificationType } from '../../../helpers/enum';
import { getClientDataFull } from '../../../services/clients';
import { getLastCreditByClient } from '../../../services/credit';
import { clientRegistrationSteps } from '../../../helpers/enum';
import { getCities } from "../../../services/cities";
import { formatPrice } from '../../../helpers/price';
import { postGestionPoliticas, postSimulation, postSimulationPricing } from '../../../services/simulation';
import { credits, creditLinesBack, CreditDestination, CreditDestinationSelect } from '../../../helpers/enum';
import { getCreditsByAdvisor } from '../../../services/credit';
import colors from '../../../assets/styles/colors';
import { BsExclamation } from 'react-icons/bs';
import { saveSimulationResult } from '../../../services/simulation';
import InputCheckbox from '../../../components/InputCheckbox';
import {
  FinancesDataTotal,
  FinancesDataTotalTitle,
  FinancesDataTotalPrice,
  FinancesDataButtoCalculate,
  FinancesDataButtoCalculateButton,
  FinancesDataCreditLine,
  FinancesDataCreditLineTitle,
  FinancesDataCreditCheckboxContainer,
  FinancesDataCreditCheckboxContainerLine,
  FinancesDataCreditCheckboxContainerText,
  FinancesDataCreditCheckboxContainerTitle,
  FinancesDataCreditCheckboxContainerSaldo,
  FinancesDataAddButton,
  FinancesDataFieldContent,
  FinancesDataFieldInputTitle,
  FinancesDataFieldTitle,
  FinancesDataFieldTitleValorLabel,
  FinancesDataFieldTitleValorDeleteItem,
  FinancesDataFieldContainer,
  FinancesDataTotalFieldsCredits,
  FinancesDataTotalFieldsCreditsLabel,
  FinancesDataTotalFieldsCreditsValue,
  SaldoTotalRecoger,
  SaldoTotalRecogerContainer,
  FinancesDataNoCredit
} from '../FinancesData/styles';
import ModalInfo from '../../../components/ModalInfo';
import Buscar from '../../../assets/images/buscar.svg';
import InputDate from '../../../components/InputDate';
import { calculateDate } from '../../../helpers/date';
import { getEducational } from '../../../services/educational';
import { getContractTypes, getExtracts } from '../../../services/extract';
import infoCircle from '../../../assets/images/info-circle.svg';
import { getActivities, getActivitiesPorIdPagaduria } from '../../../services/actividades';
import { getPiloto } from '../../../services/desk';


const OldPriceValueToSolicitatePage = ({ setActiveStep, setLastStep, setShowModal }) => {
  const { simulator, setSimulator } = useContext(SimulatorContext);
  const { register, handleSubmit, setValue, watch, control, clearErrors, errors } = useForm({ defaultValues: simulator.priceValueToSolicitate });
  const [isLoading, setIsLoading] = useState(false);
  const [tasas, setTasas] = useState([]);
  const [showTasa, setShowTasa] = useState(false);
  const [calculate, setCalculate] = useState(true);
  const [valorTea, setValorTea] = useState(0.00);
  const [paymentBill, setPaymentBill] = useState([]);
  const [filteredPaymentBill, setFilteredPaymentBill] = useState([]);
  const [showPaymentBill, setShowPaymentByll] = useState(false);
  const [showState, setShowState] = useState(false);
  const [showCity, setShowCity] = useState(false);
  const [showElement, setShowElement] = useState(false);
  const [states, setStates] = useState([]);
  const [disabledForm, setDisabledForm] = useState(true);
  const [titleErrorOnCalculate, setTitleErrorOnCalculate] = useState('');
  const [titleErrorIngresos, setTitleErrorIngresos] = useState('');
  const [showLineOfCredit, setShowLineOfCredit] = useState(false);
  const [creditsByAcesor, setCreditsByAcesor] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);
  const [filteredStates, setFilteredStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [totalFieldsCredit, setTotalFieldsCredit] = useState(0);
  const [isCreditsByAcesor, setIsCreditsByAcesor] = useState(false);
  const [messageErrorOnCalculate, setMessageErrorOnCalculate] = useState('');
  const [clientDataSearchIdentificationType, setClientDataSearchIdentificationType] = useState("");
  const [clientDataSearchIdentification, setClientDataSearchIdentification] = useState("");
  const [clientDataSearchError, setClientDataSearchError] = useState("");
  const [clientDataSearchErrorVisible, setClientDataSearchErrorVisible] = useState("");
  const fields = watch();
  const [showModalInfoIngresos, setShowModalInfoIngresos] = useState(false);
  const [showModalInfoError, setShowModalInfoError] = useState(false);
  const [showEducationalLevel, setShowEducationalLevel] = useState(false);
  const [showContractType, setShowContractType] = useState(false);
  const [educationalLevel, setEducationalLevel] = useState([]);
  const [contractTypes, setContractsType] = useState([]);
  const [showExtracts, setShowExtracts] = useState(false);
  const [extracts, setExtracts] = useState([]);
  const [showError, setShowError] = useState(false);
  const [simulatorOne, setSimulatorOne] = useState(true);
  const [showModalInfoProduct, setShowModalInfoProduct] = useState(false);
  const [messageErrorProduct, setMessageErrorProduct] = useState('');
  const [titleErrorProduct, setTitleErrorProduct] = useState('');
  const [valorTea1, setValorTea1] = useState(0.00);
  const [showActivity, setShowActivity] = useState(false);
  const [activities, setActivities] = useState([]);
  const [showModalNullContract, setShowModalNullContract] = useState(false);
  const [pilotoPagaduria, setPilotoPagaduria] = useState(false);
  const [gestionPoliticasMessage, setGestionPoliticasMessage] = useState('');
  const [gestionPoliticas, setGestionPoliticas] = useState(false);

  async function initializedStateComponent() {
    try {
      setIsLoading(true);
      setInitiarDiasIniciales();
      setIdentificationRadioChecked({ label: 'CC', value: 'CC' })
      const isPricingResponse = await isPricing(simulator.desk.id);
      const isPilotoPagaduria = await getPiloto(simulator.desk.id);
      setPilotoPagaduria(isPilotoPagaduria.data.isModeloPagaduria)
      if(!isPilotoPagaduria.data.isModeloPagaduria){
        const activities = await getActivities();
        await setActivities(activities.data);
      }

      if (!isPricingResponse.data) {
        const tasas = await getTasas();
        await setTasas(tasas.data);
        const tasa = tasas.data.find(item => (item.id === simulator.priceValueToSolicitate.tasa.id || item.id == simulator.priceValueToSolicitate.tasa));
        await setSelectedTasa(tasa);
      }

      setSimulator({
        type: SimulatorTypes.SET_PRICING,
        pricing: isPricingResponse.data
      })

      const paymentBill = await getPaymentBill();
      const states = await getStates();
      const educationalLevelReponse = await getEducational();
      const extractResponse = await getExtracts();
      //const activities = await getActivities();

      if (simulator.clientData.estrato) {
        extractResponse.data.map((item) => {
          if (item.nombre == simulator.clientData.estrato) {
            selectExtract(item);
          }
        });
      }

      if (simulator.clientData.departamento) {
        states.data.map((item) => {
          if (item.id == simulator.clientData.departamento) {
            setSelectedState(item);
          }
        });
      }

      if (simulator.priceValueToSolicitate.nivelEscolaridad) {
        educationalLevelReponse.data.map((item) => {
          if (item.idLegado === simulator.priceValueToSolicitate.nivelEscolaridad) {
            selectEducationalLevel(item);
          }
        });
      }
      if (simulator.clientData.genero) {
        setValue("genero", simulator.clientData.genero)
      }
      if (simulator.financesData.ingresos) {
        setValue("ingresos", simulator.financesData.ingresos)
      }
      if (simulator.financesData.descuentosLey) {
        setValue("descuentosLey", simulator.financesData.descuentosLey)
      }
      if (simulator.clientData.actividadCliente) {
        const actividad = activities.data.find(item => item.id === simulator.clientData.actividadCliente?.id);
        setSelectedActivitie(actividad);
      }
      await setEducationalLevel(educationalLevelReponse.data);
      await setExtracts(extractResponse.data);
      await setStates(states.data);
      setPaymentBill(paymentBill.data);
      setDisabledForm(true);
      autoCompleteData();
      setMessageErrorOnCalculate('');
      setTitleErrorOnCalculate('Error en el servicio OnboardingServices');

    } catch (error) {
      console.log(error.response)
    }
  }

  function autoCompleteData() {
    if (simulator.clientData.fechaNacimiento) {
      setValue("fechaNacimiento", simulator.clientData.fechaNacimiento)
      let years = calculateDate(simulator.clientData.fechaNacimiento);
      setValue("edad", years);
      setSimulator({
        type: SimulatorTypes.SET_YEARS_OLD_BY_DATE,
        edad: years
      })
    }
    if (simulator.clientData.identificacion) {
      setValue("identificacion", simulator.clientData.identificacion)
    }
  }

  useEffect(() => {
    if (simulator.desk.id) {
      ispricing();
    }
  }, [simulator.desk.id]);

  async function ispricing() {
    const isPricingResponse = await isPricing(simulator.desk.id);
    await setSimulator({
      type: SimulatorTypes.SET_PRICING,
      pricing: isPricingResponse.data
    })
  }

  function setSelectedTasa(tasa) {
    setValue("tasa", tasa);
    clearErrors("tasa", {});


    setSimulator({
      type: SimulatorTypes.SET_RATE,
      tasa: tasa
    })

    if (simulator.pricing) {
      setSimulator({
        type: SimulatorTypes.SET_TASA,
        rate: tasa.id
      })
    }
    if (tasa !== undefined) {
      handleCalculateTea(parseFloat(tasa.id), 0);
    }
  }

  function selectExtract(estrato) {
    setValue("estrato", estrato);
    setSimulator({
      type: SimulatorTypes.SET_EXTRACT,
      estrato: estrato
    })
  }

  async function setSelectedState(state) {
    try {
      setIsLoading(true);
      const cities = await getCities(state.id);
      setCities(cities.data);

      setValue('departamento', state.nombre);
      setSimulator({
        type: SimulatorTypes.SET_SELECTED_STATE,
        state
      });

      const isPricingResponse = await isPricing(simulator.desk.id);
      if (!isPricingResponse.data) {
        await updateTasa(simulator.clientData.pagaduria?.id, state.id);
      }

      if (simulator.clientData.ciudad?.id) {
        cities.data.map((item) => {
          if (item.id == simulator.clientData.ciudad.id) {
            setSelectedCity(item);
          }
        });
      }


      setIsLoading(false);
      setShowState(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  function selectEducationalLevel(educationaLevel) {
    setValue("nivelEscolaridad", educationaLevel);
    clearErrors("nivelEscolaridad", {});
    setSimulator({
      type: SimulatorTypes.SET_EDUCATIONAL_LEVEL,
      nivelEscolaridad: educationaLevel
    })
    setShowEducationalLevel(false);
  }

  function selectContractType(contracttype) {
    setValue("tipoDeContrato", contracttype);
    clearErrors("tipoDeContrato", {});

    setSimulator({
      type: SimulatorTypes.SET_CONTRACT_TYPE,
      tipoContrato: contracttype
    })
    setShowContractType(false);
  }

  async function setSelectedCity(city) {
    setValue('ciudad', city.nombre);
    setSimulator({
      type: SimulatorTypes.SET_SELECTED_CITY,
      city
    });
    setShowCity(false);
  }

  function handleCalculateDate() {
    let years = calculateDate(fields.fechaNacimiento);
    setValue("edad", years);

    setSimulator({
      type: SimulatorTypes.SET_FECHA_NASCIMENTO,
      fechaNacimiento: fields.fechaNacimiento
    })
    setSimulator({
      type: SimulatorTypes.SET_YEARS_OLD_BY_DATE,
      edad: years
    })
  }

  function searchInCities(e) {
    setShowCity(true);
    setShowState(false);
    let filtered = cities.filter(city => city.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredCities(filtered);
  }

  function searchInState(e) {
    setShowState(true);
    setShowCity(false);
    let filtered = states.filter(city => city.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredStates(filtered);
  }

  function setInitiarDiasIniciales() {
    setValue("diasInteresesIniciales", 120);
    clearErrors("diasInteresesIniciales", {});
  }


  function setIdentificationRadioChecked(radio) {
    setSimulator({
      type: SimulatorTypes.SET_IDENTIFICATION_TYPE,
      tipoIdentificacion: radio.value,
      identificacion: ''
    })
    setClientDataSearchIdentificationType(radio.value);
    setValue('identificacion', '');
  }

  function setCompleteStep(data) {
    data.pricingProduct = simulator.priceValueToSolicitate.pricingProduct;
    data.nivelEscolaridad = simulator.priceValueToSolicitate.nivelEscolaridad;
    data.tipoContrato = simulator.priceValueToSolicitate.tipoContrato;
    setIsLoading(true);
    setSimulator({
      type: SimulatorTypes.SET_PRICE_VALUE_TO_SOLICITATE,
      priceValueToSolicitate: data
    })
    data.tasa = simulator.priceValueToSolicitate.tasa;
    if(gestionPoliticas){
    if (simulator.pricing) {
      if (simulator.priceValueToSolicitate.tipoContrato?.nombre) {
        setIsLoading(false);
        setLastStep(simulatorSteps.PRICE_VALUE_TO_SOLICITATE);
        setActiveStep(simulatorSteps.RESULT);
      } else {
        setIsLoading(false);
        setShowModalNullContract(true);
      }
    } else {
      setIsLoading(false);
      setLastStep(simulatorSteps.PRICE_VALUE_TO_SOLICITATE);
      setActiveStep(simulatorSteps.RESULT);
    }
  }else{
    setShowModalInfoError(true);
    setTitleErrorOnCalculate(gestionPoliticasMessage);
  }
    setIsLoading(false);
  }

  async function loadClientDataForIdentification() {
    try {
      setIsLoading(true);
      var tipoIdentificacion = clientDataSearchIdentificationType;
      var identificacion = clientDataSearchIdentification?.replaceAll('.', '');
      var pagaduria = null;
      var departamento = null;
      if (!identificacion) {
        showClientDataSearchError("Ingrese un número de identificación");
      } else {
        var response = await getClientDataFull(tipoIdentificacion, identificacion);
        if (response.data && response.data.id) {
          setSimulator({
            type: SimulatorTypes.SET_CLIENT_DATA,
            clientData: response.data
          });
          if (response.data.pagaduria) {
            setSimulator({
              type: SimulatorTypes.SET_PAYMENT_BILL,
              pagaduria: response.data.pagaduria
            });
            pagaduria = response.data.pagaduria.id;
            setSelectedPaymentBill(response.data.pagaduria)
            //setPaymentBill(response.data.pagaduria)
          }
          /* Comentado por cambio de alcance en modelo de tasas*/
          /*
          if(response.data.ciudadResidencia) {
              if(response.data.ciudadResidencia.id) {
                setSimulator({
                  type: SimulatorTypes.SET_SELECTED_CITY,
                  city: {
                    id: response.data.ciudadResidencia.id,
                    nombre: response.data.ciudadResidencia.nombre
                  }
                });
              }
              if(response.data.ciudadResidencia.departamento) {
                setSimulator({
                  type: SimulatorTypes.SET_SELECTED_STATE,
                  state: {
                    id: response.data.ciudadResidencia.departamento,
                    nombre: response.data.ciudadResidencia.departamento.split('>')[1]
                  }
                });
                departamento = response.data.ciudadResidencia.departamento;
              }
          }*/
          response = await getLastCreditByClient(response.data.id);
          if (response.data) {
            setSimulator({
              type: SimulatorTypes.SET_ACTIVITIE,
              actividadCliente: {
                id: response.data.actividad,
                nombre: toUpperFirst(response.data.actividad)
              }
            });
          }
          if (!simulator.pricing) {
            updateTasa(pagaduria, departamento);
          }
        } else {
          showClientDataSearchError("No se encontraron datos para el cliente");
        }
      }
    } catch (error) {
      showClientDataSearchError("No se pudieron obtener los datos del cliente");
      console.log(error.response)
    }
    setIsLoading(false);
  }

  async function getCredits() {
    const data = {
      tipoIdentificacion: simulator.clientData.tipoIdentificacion,
      identificacion: simulator.clientData.identificacion.replaceAll('.', '')
    }

    setIsLoading(true);
    const credits = await getCreditsByAdvisor(data,simulator.desk.id);
    setIsLoading(false);
    setCreditsByAcesor(credits.data);
    setIsCreditsByAcesor(true);
  }

  function setSelectedLineOfCredit(lineOfCredit) {
    setValue("lineaCredito", lineOfCredit.nombre);
    clearErrors("lineaCredito", []);
    setCalculate(true);
    setTotalFieldsCredit(0)
    setDisabledForm(true);

    if ((lineOfCredit.idBackend === creditLinesBack[2].id || lineOfCredit.idBackend === creditLinesBack[3].id) && !isCreditsByAcesor) {
      getCredits();
    } else {
      setIsLoading(false);
    }

    if (simulator.financesData.lineaCredito.idBackend === creditLinesBack[1].id || simulator.financesData.lineaCredito.idBackend === creditLinesBack[3].id) {
      setSimulator({
        type: SimulatorTypes.SET_DEFAULT_INPUT,
        fields: [{ id: 0, value: '' }]
      })
    }

    if (simulator.financesData.lineaCredito.idBackend === creditLinesBack[2].id || simulator.financesData.lineaCredito.idBackend === creditLinesBack[3].id) {
      setSimulator({
        type: SimulatorTypes.SET_DEFAULT_CREDIT,
        credits: []
      })
    }

    setSimulator({
      type: SimulatorTypes.SET_LINE_OF_CREDIT,
      lineaCredito: lineOfCredit
    })

    verifyFields();
  }

  async function updateTasa(pagaduria, departamento) {
    if (pagaduria && departamento) {
      var response = await getTasasFilter(pagaduria, departamento);
      if (response.data) {
        const tasa = response.data.find(item => (item.id === simulator.priceValueToSolicitate.tasa?.id || item.id == simulator.priceValueToSolicitate.tasa));
        setSelectedTasa(tasa);
        setTasas(response.data);
      }
    }
  }



  function verifyCheckbox(checkbox) {
    let res = false;
    getListofCredits().forEach(item => {
      if (item.id === checkbox.id) {
        res = true;
        return;
      }
    });
    return res;
  }

  function toUpperFirst(str) {
    return str == '' || str == null ? str :
      str[0].toUpperCase() + (str.length > 1 ? str.substring(1).toLowerCase() : '');
  }

  function formatTasa(tasa) {
    return "" + tasa + " %";
  }

  function calculateTea(tasa) {
    return Math.ceil(((Math.pow(1 + tasa / 100, 12.0)) - 1) * 10000) / 100;
  }

  function handleCalculateTea(tasa, id) {
    const tea = calculateTea(tasa);
    setValorTea(tea);
    setValue("tea", formatTasa(tea));
    if (id == 2) {
      setValorTea(tea);
      setValue("tea", formatTasa(tea));
    }
    if (id == 1) {
      setValorTea1(tea);
      setValue("tea1", formatTasa(tea));
    }
  }

  function setGenderRadioChecked(genero) {
    setSimulator({
      type: SimulatorTypes.SET_TAKER_GENDER,
      genero: genero.value
    })
  }

  async function setSelectedPaymentBill(paymentBill) {
    setValue("pagaduria", paymentBill.nombre);
    clearErrors("pagaduria", {});
    if(pilotoPagaduria){
      const response = await getActivitiesPorIdPagaduria(paymentBill.id);
      const objetoEncontrado = response.data.find((elemento) => {
        return elemento.nombre === simulator.clientData.actividadCliente?.nombre;
      }) 
      if(!objetoEncontrado && simulator.clientData.actividadCliente.id != undefined){
        setSelectedActivitie({});
      }
      if(simulator.clientData.actividadCliente){
        response.data.map((item) => {
          if (simulator.clientData.actividadCliente == item.nombre) {
            setSelectedActivitie(item);
          }
        });
      }
      setActivities(response.data);
    }

    setSimulator({
      type: SimulatorTypes.SET_PAYMENT_BILL,
      pagaduria: paymentBill
    })
    if (!simulator.pricing) {
      await updateTasa(paymentBill.id, simulator.clientData.departamento?.id);
    }
    setShowPaymentByll(false);
  }

  function canUseSelectRate() {
    if (fields.plazo && fields.monto && simulator.financesData.ingresos && simulator.financesData.descuentosLey && simulator.clientData.ciudad?.nombre &&
      simulator.clientData.pagaduria?.nombre && simulator.clientData.departamento?.nombre && simulator.financesData.lineaCredito?.nombre) {
      return true;
    } else {
      return false
    }
  }

  function canUseSelectRatePricing() {
    if (fields.plazo && fields.monto && simulator.clientData.departamento?.nombre && simulator.financesData.ingresos
      && simulator.financesData.descuentosLey && simulator.clientData.ciudad?.nombre && simulator.clientData.pagaduria?.nombre && simulator.clientData.departamento?.nombre
      && simulator.clientData.genero && simulator.priceValueToSolicitate.nivelEscolaridad?.nombre && simulator.financesData.lineaCredito?.nombre) {
      return true;
    } else {
      return false
    }
  }



  function onChangeIdentification(e) {
    var identificacion = undefined;
    if (simulator.clientData.tipoIdentificacion === 'CE') {
      identificacion = e.target.value;
    } else {
      identificacion = handleChangeIdentification(e.target.value);
    }
    setValue('identificacion', identificacion);
    // setSimulator({
    //   type: SimulatorTypes.SET_IDENTIFICATION,
    //   identificacion: identificacion
    // }); 
    setClientDataSearchIdentification(identificacion);
    setClientDataSearchErrorVisible(false);
  }

  function showClientDataSearchError(error) {
    setClientDataSearchError(error);
    setClientDataSearchErrorVisible(true);
  }

  function searchInPaymentBill(e) {
    setShowPaymentByll(true);
    let filtered = paymentBill.filter(paymentBill => paymentBill.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredPaymentBill(filtered);
  }

  async function doSimulation() {
    setIsLoading(true);
    const req = {
      idPagaduria: simulator.clientData.pagaduria?.id,
      idLineaCredito: simulator.financesData.lineaCredito.idBackend,
      idOficina: -1,
      actividadCliente: simulator.clientData.actividadCliente.id,
      tasa: parseFloat(simulator.priceValueToSolicitate.tasa?.nombre.replace('% ', '')),
      plazo: parseInt(fields.plazo),
      monto: parseInt(fields.monto),
      diasInteresesIniciales: 120,
      ingresos: parseInt(simulator.financesData.ingresos),
      cliente: {
        identificacion: /*simulator.clientData.identificacion.replaceAll('.', '')*/fields.identificacion.replaceAll('.', ''),
        fechaNacimiento: simulator.clientData.fechaNacimiento
      },
      descuentosLey: (simulator.financesData.descuentosLey) ? parseInt(simulator.financesData.descuentosLey) : 0,
      descuentosNomina: (simulator.financesData.descuentosNomina) ? parseInt(simulator.financesData.descuentosNomina) : 0,
      carteras: [],
      departamento: simulator.clientData.departamento?.id,
      genero: simulator.clientData.genero,
      nivelEducativo: simulator.priceValueToSolicitate.nivelEscolaridad?.idLegado,
      tipoContrato: simulator.priceValueToSolicitate.tipoContrato?.nombre,
      productPricing: simulator.priceValueToSolicitate.pricingProduct,
      totalActivos: fields.totalActivos,
      estrato: simulator.clientData.estrato?.nombre,
      simulador1: true,
    }

    const walletFields = simulator.financesData.fields.map(item => {
      return {
        monto: item.value
      }
    });

    if (simulator.financesData.lineaCredito.idBackend === creditLinesBack[1].id || simulator.financesData.lineaCredito.idBackend === creditLinesBack[3].id) {
      req.carteras = walletFields;
    }

    if (simulator.financesData.lineaCredito.idBackend === creditLinesBack[2].id || simulator.financesData.lineaCredito.idBackend === creditLinesBack[3].id) {
      req.idCreditoPadre = getListofCredits().map(credito => credito.id)
    }

    const req2 = { ...req };
    req2.productPricing = simulator.priceValueToSolicitate.pricingProduct1;
    req2.tasa = simulator.priceValueToSolicitate.pricingProduct1?.rate;

    try {
      const simulation = await postSimulation(req);
      setSimulator({
        type: SimulatorTypes.SET_SIMULATION,
        simulation: simulation.data
      })
      if (simulator.pricing) {
        const simulation1 = await postSimulation(req2);
        setSimulator({
          type: SimulatorTypes.SET_SIMULATION1,
          simulation1: simulation1.data
        })
      }
      const data = {
        term: parseInt(fields.plazo),
        amount: parseInt(simulation.data.montoTotalCredito),
        birthdate: fields.fechaNacimiento,
        identification: fields.identificacion.replaceAll('.', ''),
        idPagaduria: simulator.clientData.pagaduria?.id,
      }
      const gestionPoliticasResponse = await postGestionPoliticas(data);
      setGestionPoliticas(gestionPoliticasResponse.data.result);
      setGestionPoliticasMessage(gestionPoliticasResponse.data.message);
      if(gestionPoliticasResponse.data.result){
        setIsLoading(false);
        setShowElement(true);
      }else{
        setIsLoading(false);
        setShowModalInfoError(true);
        setTitleErrorOnCalculate(gestionPoliticasResponse.data.message);
      }
      setDisabledForm(false);
    } catch (error) {
      setDisabledForm(true);
      setShowModalInfoError(false);
      console.log(error.response)
      setTitleErrorOnCalculate(error.message);
    }
  }

  function getListofCredits() {
    return (simulator.financesData.credits.length === undefined) ? [simulator.financesData.credits] : simulator.financesData.credits;
  }

  function verifyFields() {
    let { ingresos, descuentosNomina, descuentosLey } = fields;

    setSimulator({
      type: SimulatorTypes.SET_VALUE_FIELDS_OF_FINANCES,
      ingresos,
      descuentosNomina,
      descuentosLey
    })
  }


  function validateIngresos() {
    let { ingresos, descuentosNomina, descuentosLey } = fields;
    if (Number(ingresos) < Number(descuentosNomina) + Number(descuentosLey)) {
      setTitleErrorIngresos("Campos de descuentos no deben ser superiores a los ingresos.");
      setShowModalInfoIngresos(true);
      setDisabledForm(true);
      return false;
    }
    return true;
  }

  function deleteFieldFromStore(field) {
    let fields = simulator.financesData.fields;
    fields = fields.filter(item => item.id !== field.id);

    setSimulator({
      type: SimulatorTypes.SET_FIELDS,
      fields
    })
  }

  function calculateData() {
    if (validateIngresos()) {
      doSimulation();
      
    }

  }

  function setCreditToStore(credit) {
    const newCredit = {
      id: credit.id,
      numeroRadicacion: credit.numeroRadicacion,
      saldoAlDia: credit.saldoAlDia
    }
    const filtered = getListofCredits().filter(credito => credito.id === credit.id);
    if (filtered.length > 0) {
      const newCreditList = getListofCredits().filter(credito => credito.id !== credit.id);
      setSimulator({
        type: SimulatorTypes.SET_CREDIT_CHECKBOX,
        credits: newCreditList
      });
    } else {
      setSimulator({
        type: SimulatorTypes.SET_CREDIT_CHECKBOX,
        credits: [...getListofCredits().filter(credito => credito.id !== undefined), newCredit]
      });
    }

    verifyFields()
  }

  function modalErrorResetDefault() {
    setShowModalInfoError(false)
    setMessageErrorOnCalculate('');
    setTitleErrorOnCalculate('Error en el servicio OnboardingServices');
  }



  function onChangeField(name, key, value) {
    let fields = simulator.financesData.fields;
    setValue(name, value);

    let totalSum = 0;
    fields.forEach(item => {
      if (item.id === key) {
        item.value = value
      }
      totalSum += item.value;
    });

    setTotalFieldsCredit(totalSum);

    setSimulator({
      type: SimulatorTypes.SET_FIELDS,
      fields
    })

    verifyFields()
  }

  useEffect(() => {
    setIsLoading(true);
    initializedStateComponent();
    setIsLoading(false);
    return () => {
      setTasas([]);
      setFilteredPaymentBill([]);
    }
  }, []);

  useEffect(() => {
    if (simulator.financesData.ingresos && simulator.financesData.ingresos !== '0' && simulator.financesData.lineaCredito.idBackend && simulator.priceValueToSolicitate.tasa?.nombre && fields.identificacion) {
      if (simulator.financesData.lineaCredito.idBackend === creditLinesBack[1].id) {
        if (simulator.financesData.fields[0].value > 0) {
          setCalculate(false)
        } else {
          setCalculate(true)
        }
      } else if (simulator.financesData.lineaCredito.idBackend === creditLinesBack[2].id) {
        if (getListofCredits().length > 0 && creditsByAcesor.length > 0) {
          setCalculate(false)
        } else {
          setCalculate(true)
        }
      } else if (simulator.financesData.lineaCredito.idBackend === creditLinesBack[3].id) {
        if (simulator.financesData.fields[0].value > 0 && getListofCredits().length > 0 | !creditsByAcesor.length) {
          setCalculate(false)
        } else {
          setCalculate(true)
        }
      } else {
        setCalculate(false)
      }
    } else {
      setCalculate(true);
    }

  }, [simulator.financesData, simulator.priceValueToSolicitate.tasa, fields.identificacion])


  function canUseForm() {
    if (simulator.desk.id) {
      return true;
    } else {
      return false
    }
  }

  async function getProductPricing() {
    if (simulator.desk.id) {
      const req = {
        genero: simulator.clientData.genero,
        departamento: simulator.clientData.departamento?.nombre,
        nivel_educativo: simulator.priceValueToSolicitate.nivelEscolaridad?.idLegado,
        id_pagaduria: simulator.clientData.pagaduria?.id,
        fecha_nacimiento: fields.fechaNacimiento,
        tipo_contrato: simulator.priceValueToSolicitate.tipoContrato?.nombre,
        nombre_pagaduria: simulator.clientData.pagaduria?.nombre,
        total_activos: fields.totalActivos,
        descuentos_nomina: simulator.financesData.descuentosNomina
      }
      setSimulatorOne(true);
      /*const response = await getTasasPricing(req, simulatorOne);
      const rates = response.data.rates;
      const ratesWithSymbol = rates.map(rate => ({
        id: rate,
        nombre: rate + '%',
      }))
      setTasas(ratesWithSymbol);*/
      const response = await getTasasPricingAndCifin(req);
      response.data.map((item) => {
        if (item.id == 2) {
          const tasaObjeto = { id: item.rate, nombre: (item.rate + '%') }
          setSelectedTasa(tasaObjeto);
          setSimulator({
            type: SimulatorTypes.SET_PRODUCT,
            pricingProduct: {
              rate: item.rate,
              suretyBond: item.suretyBond,
              creditStudy: item.creditStudy,
              productGroupId: item.productGroupId,
              deterioration: item.deterioration,
              rates: item.rates,
              groupNumber: item.groupNumber
            }
          })
          if (!item.enabled) {
            setMessageErrorProduct(response.data.message);
            setShowModalInfoProduct(true);
            setTitleErrorProduct('Vigencia del grupo ' + response.data.groupNumber);
          }
          handleCalculateTea(tasaObjeto.id, item.id)
        } else {
          const tasaObjeto = { id: item.rate, nombre: (item.rate + '%') };
          setSimulator({
            type: SimulatorTypes.SET_PRODUCT1,
            pricingProduct1: {
              rate: item.rate,
              suretyBond: item.suretyBond,
              creditStudy: item.creditStudy,
              productGroupId: item.productGroupId,
              deterioration: item.deterioration,
              rates: item.rates,
              groupNumber: item.groupNumber
            }
          })
          if (!item.enabled) {
            setMessageErrorProduct(item.message);
            setShowModalInfoProduct(true);
            setTitleErrorProduct('Vigencia del grupo ' + item.groupNumber);
          }
          handleCalculateTea(tasaObjeto.id, item.id);
        }
      })

      //setValue("groupNumber",response.data.groupNumber);

    }
  }

  async function setSelectedActivitie(activitie) {
    setValue("actividadCliente", activitie);
    clearErrors("actividadCliente", {});
    if(activitie.id != undefined){
    const contractTypes = await getContractTypes(activitie.id);
    const objetoEncontrado = contractTypes.data.find((elemento) => {
      return elemento.nombre === simulator.priceValueToSolicitate.tipoContrato?.nombre;
    });
    if(!objetoEncontrado){
      selectContractType({});
    }
    if (simulator.priceValueToSolicitate.tipoContrato) {
      contractTypes.data.map((item) => {
        if (item.nombre == simulator.priceValueToSolicitate.tipoContrato) {
          selectContractType(item);
        }
      });
    }
    setContractsType(contractTypes.data);
    }else{
      selectContractType({});
    }
    setSimulator({
      type: SimulatorTypes.SET_ACTIVITIE,
      actividadCliente: activitie
    })
  }

  useEffect(() => {
    if (simulator.pricing && simulator.clientData.genero && simulator.clientData.departamento?.nombre && simulator.priceValueToSolicitate.nivelEscolaridad?.nombre
      && simulator.clientData.edad && simulator.clientData.pagaduria?.nombre && simulator.financesData.descuentosNomina && simulator.priceValueToSolicitate.tipoContrato?.nombre) {
      getProductPricing();
    }
  }, [simulator.clientData, simulator.financesData, simulator.priceValueToSolicitate.nivelEscolaridad, simulator.priceValueToSolicitate.tipoContrato,
  fields.totalActivos,])



  return (
    <FormTemplate
      idForm="price-value-to-solicitate-step-page"
      idButton="new-simulation"
      labelButton="Nueva simulación"
      activeStep="1/3"
      stepLabel="Valores crédito a solicitar"
      actionHeaderButton={setShowModal}>
      <Form onSubmit={handleSubmit(setCompleteStep)}>
        <FormRow>
          <RadioButtonForm
            label="Tipo de documento"
            setIdentificationRadioChecked={setIdentificationRadioChecked}
            defaultValue="CC"
            selected={simulator.clientData.tipoIdentificacion}
            name="tipoIdentificacion"
            id="tipoIdentificacion"
            register={register({ required: "Este dato es obligatorio" })}
            radios={[
              { label: 'CC', value: 'CC' }
            ]} />
        </FormRow>
        <FormRow>
          <Controller
            name="identificacion"
            control={control}
            value={simulator.clientData.identificacion}
            disabled={!canUseForm()}
            render={() => (
              <InputDefault
                name="identificacion"
                label="Número de documento de identidad"
                register={register({
                  required: "Este dato es obligatorio",
                  pattern: {
                    value: /^\d+(\.\d+)*$/,
                    message: "Error en el número, ingresa uno válido",
                  }
                })}
                id="identificacion"
                error={errors.identificacion}
                maxLength={simulator.clientData.tipoIdentificacion === 'CE' ? identificationType.ce.max : identificationType.cc.max}
                minLength={simulator.clientData.tipoIdentificacion === 'CE' ? identificationType.ce.min : identificationType.ce.min}
                onChange={onChangeIdentification}
              />
            )}
          />
          <ClientDataSearchColumn>
            <ClientDataSearchError visible={clientDataSearchErrorVisible}>{clientDataSearchError}</ClientDataSearchError>
            <DefaultSmallButtonBuscar type="button" id="load-client-data" onClick={loadClientDataForIdentification}> <img src={Buscar} alt="button"></img> </DefaultSmallButtonBuscar>
          </ClientDataSearchColumn>
        </FormRow>
        <FormRow col="2">
          <SearchField
            label="Departamento de Expedición Documento"
            name="departamento"
            id="departamento"
            disabled={!canUseForm()}
            show={showState}
            list={filteredStates}
            defaultValue={simulator.clientData.departamento?.nombre}
            selectField={setSelectedState}
            searchInList={searchInState}
            register={register({ required: "Este dato es obligatorio" })}
            placeholder="Buscar..."
            error={errors.departamento} />
          <SearchField
            label="Ciudad o Municipio de Expedición Documento"
            name="ciudad"
            id="ciudad"
            show={showCity}
            list={filteredCities}
            defaultValue={simulator.clientData.ciudad?.nombre}
            selectField={setSelectedCity}
            searchInList={searchInCities}
            register={register({ required: "Este dato es obligatorio" })}
            placeholder="Buscar..."
            error={errors.city}
            disabled={!simulator.clientData.departamento} />
        </FormRow>
          <FormRow col="2">
            <InputDate
              aria-required
              disabled={!canUseForm()}
              type="date"
              label="Fecha de nacimiento"
              name="fechaNacimiento"
              register={register({ required: "Este dato es obligatorio" })}
              id="fechaNacimiento"
              onBlur={handleCalculateDate}
              error={errors.fechaNacimiento} />
            <Controller
              as={InputDefault}
              control={control}
              label="Edad cliente"
              name="edad"
              register={register}
              id="yearsold"
              error={errors.edad}
              readOnly={true}
              value={simulator.clientData.edad} />
          </FormRow>
          <FormRow>
          <SearchField
            disabled={!canUseForm()}
            label="Pagaduría"
            name="pagaduria"
            id="pagaduria"
            show={showPaymentBill}
            list={filteredPaymentBill}
            defaultValue={simulator.clientData.pagaduria?.nombre}
            selectField={setSelectedPaymentBill}
            searchInList={searchInPaymentBill}
            register={register({ required: "Este dato es obligatorio" })}
            error={errors.pagaduria}
            placeholder="Buscar..." />
            <Select
              error={errors.actividadCliente}
              setShow={setShowActivity}
              show={showActivity}
              defaultValue={simulator.clientData.actividadCliente?.nombre}
              setSelected={setSelectedActivitie}
              list={activities}
              placeholder={simulator.clientData.pagaduria?.nombre ? "Seleccionar..." : "Seleccione una pagaduria..."}
              label="Actividad"
              name="actividadCliente"
              id="actividadCliente"
              register={register({ required: "Este dato es obligatorio" })}
              disabled={!simulator.clientData.pagaduria?.nombre}  />
        </FormRow>
        {simulator.pricing && <>

          <FormRow>
            <Select
              error={errors.tipoContrato}
              setShow={setShowContractType}
              show={showContractType}
              defaultValue={simulator.priceValueToSolicitate.tipoContrato?.nombre}
              setSelected={selectContractType}
              list={contractTypes}
              placeholder={simulator.clientData.actividadCliente?.nombre ? "Seleccionar..." : "Seleccione una actividad..."}
              label="Tipo de contrato / Pensión"
              name="tipoDeContrato"
              id="tipoDeContrato"
              register={register({ required: "Este dato es obligatorio" })}
              disabled={!simulator.clientData.actividadCliente?.nombre}
            />
            <Select
              disabled={!canUseForm()}
              error={errors.nivelEscolaridad}
              setShow={setShowEducationalLevel}
              show={showEducationalLevel}
              defaultValue={simulator.priceValueToSolicitate.nivelEscolaridad?.nombre}
              setSelected={selectEducationalLevel}
              list={educationalLevel}
              placeholder="Seleccionar..."
              label="Nivel de escolaridad"
              name="nivelEscolaridad"
              id="nivelEscolaridad"
              register={register({ required: "Este dato es obligatorio" })}
            />
          </FormRow>
          <FormRow> 
            <Select
              disabled={!canUseForm()}
              error={errors.estrato}
              setShow={setShowExtracts}
              show={showExtracts}
              defaultValue={simulator.clientData.estrato?.nombre}
              setSelected={selectExtract}
              list={extracts}
              placeholder="Seleccionar..."
              label="Estrato"
              name="estrato"
              id="estrato"
              register={register({ required: "Este dato es obligatorio" })}
            />
                      <InputIntl
            disabled={!canUseForm()}
            id="amount"
            label="Monto solicitado"
            error={errors.monto}
            name="monto"
            defaultValue={simulator.priceValueToSolicitate.monto}
            setValue={setValue}
            currencyConfig={currencyMoney}
            register={register({
              required: "Este dato es obligatorio",
              min: {
                value: 1,
                message: "Este dato es obligatorio"
              }
            })} />
          </FormRow>
          <FormRow>
            <InputIntl
              disabled={!canUseForm()}
              id="totalactives"
              label="Total de Activos"
              error={errors.totalActivos}
              name="totalActivos"
              defaultValue={simulator.priceValueToSolicitate.totalActivos}
              setValue={setValue}
              currencyConfig={currencyMoney}
              register={register({
                required: "Este dato es obligatorio",
                min: {
                  value: 1,
                  message: "Este dato es obligatorio"
                }
              })} />
            <RadioButtonForm
              disabled={!canUseForm()}
              label="Género"
              setIdentificationRadioChecked={setGenderRadioChecked}
              defaultValue="M"
              selected={simulator.clientData.genero}
              name="genero"
              id="genero"
              register={register({ required: "Este dato es obligatorio" })}
              radios={[
                { label: 'M', value: 'M' },
                { label: 'F', value: 'F' }
              ]} />
          </FormRow>
        </>}

        
        <FormRow col="2">
          <InputDefault
            disabled={!canUseForm()}
            aria-required
            type="number"
            label="Plazo en meses"
            name="plazo"
            register={register({
              required: "Este dato es obligatorio",
              validate: {
                minValue: (value) => parseFloat(value) >= 12 || 'El dato debe estar entre 12 y 144',
                maxValue: (value) => parseFloat(value) <= 144 || 'El dato debe estar entre 12 y 144',
              },
            })}
            placeholder="Meses"
            id="plazo"
            error={errors.plazo}
          />
          <InputIntl
            disabled={!canUseForm()}
            id="ingresos"
            label="Total ingresos mensuales"
            error={errors.ingresos}
            name="ingresos"
            defaultValue={simulator.financesData.ingresos}
            setValue={setValue}
            currencyConfig={currencyMoney}
            register={register({
              required: "Este dato es obligatorio",
              min: {
                value: 1,
                message: "Este dato es obligatorio"
              }
            })}
            onBlur={() => verifyFields()} />

        </FormRow>

        <FormRow>
          <InputIntl
            disabled={!canUseForm()}
            id="descuentosNomina"
            label="Otros Descuentos"
            error={errors.descuentosNomina}
            name="descuentosNomina"
            defaultValue={simulator.financesData.descuentosNomina || 0}
            setValue={setValue}
            currencyConfig={currencyMoney}
            register={register({
              min: {
                value: 0,
                message: "Este dato es obligatorio"
              }
            })}
            onBlur={() => verifyFields()} />
          <InputIntl
            disabled={!canUseForm()}
            id="descuentosLey"
            label="Total descuentos de ley"
            error={errors.descuentosLey}
            name="descuentosLey"
            defaultValue={simulator.financesData.descuentosLey}
            setValue={setValue}
            currencyConfig={currencyMoney}
            onBlur={() => verifyFields()}
            register={register({
              required: "Este dato es obligatorio",
              min: {
                value: 0,
                message: "Este dato es obligatorio"
              }
            })}
          />
        </FormRow>
        <FormRow>
          <Select
            error={errors.lineaCredito}
            setShow={setShowLineOfCredit}
            show={showLineOfCredit}
            defaultValue={simulator.financesData.lineaCredito.nombre}
            setSelected={setSelectedLineOfCredit}
            list={credits}
            placeholder={"Seleccionar..."}
            label="Línea de Crédito"
            name="lineaCredito"
            id="lineaCredito"
            register={register({ required: "Este dato es obligatorio" })}
            disabled={!canUseForm()} />
          {/*simulator.pricing &&
            <Select
              error={errors.tasa}
              setShow={setShowTasa}
              show={showTasa}
              defaultValue={simulator.priceValueToSolicitate.tasa?.nombre}
              setSelected={setSelectedTasa}
              list={tasas}
              placeholder={canUseSelectRatePricing() ? "Seleccionar..." : "Ingrese todos los datos para continuar..."}
              label="Tasa NMV %"
              name="tasa"
              id="tasa"
              disabled={!canUseSelectRatePricing()}
          register={register({ required: "Este dato es obligatorio" })} />*/}

          {!simulator.pricing && <Select
            error={errors.tasa}
            setShow={setShowTasa}
            show={showTasa}
            defaultValue={simulator.priceValueToSolicitate.tasa?.nombre}
            setSelected={setSelectedTasa}
            list={tasas}
            placeholder={canUseSelectRate() ? "Seleccionar..." : "Ingrese todos los datos para continuar..."}
            label="Tasa NMV %"
            name="tasa"
            id="tasa"
            disabled={!canUseSelectRate()}
            register={register({ required: "Este dato es obligatorio" })} />}

        </FormRow>
        {/*simulator.pricing && 
        <FormRow>
        <InputDefault
            aria-required
            type="number"
            label="Grupo MP"
            name="groupNumber"
            register={register({ required: "Este dato es obligatorio" })}
            placeholder="Días"
            id="groupNumber"
            error={errors.groupNumber}
            maxLength="3"
            readOnly={true}
          />
          </FormRow>*/}

        <FormRowInvisible>
          <InputDefault
            aria-required
            type="number"
            label="Días intereses Iniciales"
            name="diasInteresesIniciales"
            register={register({ required: "Este dato es obligatorio" })}
            placeholder="Días"
            id="diasInteresesIniciales"
            error={errors.diasInteresesIniciales}
            maxLength="3"
            readOnly={true}
          />
        </FormRowInvisible>
        {simulator.financesData.lineaCredito.idBackend === creditLinesBack[2].id ||
          simulator.financesData.lineaCredito.idBackend === creditLinesBack[3].id ? (
          <FinancesDataCreditLine>
            <FinancesDataCreditLineTitle>Créditos activos</FinancesDataCreditLineTitle>
            <FinancesDataCreditCheckboxContainerLine>
              {!isLoading ? (
                creditsByAcesor.length ? (
                  creditsByAcesor.map((item, key) => (
                    <FinancesDataCreditCheckboxContainer>
                      <InputCheckbox onClick={() => setCreditToStore(item)}
                        checked={verifyCheckbox(item)}
                        value={item.numeroRadicacion} />
                      <FinancesDataCreditCheckboxContainerText><FinancesDataCreditCheckboxContainerTitle>Pagaduría:</FinancesDataCreditCheckboxContainerTitle>{item.pagaduria.nombre}</FinancesDataCreditCheckboxContainerText>
                      <FinancesDataCreditCheckboxContainerText>Saldo al día:</FinancesDataCreditCheckboxContainerText>
                      <FinancesDataCreditCheckboxContainerSaldo>$ {formatPrice(parseInt(item.saldoAlDia))}</FinancesDataCreditCheckboxContainerSaldo>
                    </FinancesDataCreditCheckboxContainer>
                  ))
                ) : (
                  simulator.financesData.lineaCredito.idBackend === creditLinesBack[2].id ? (
                    <FinancesDataNoCredit>Cliente no tiene creditos activos, selecciona otra línea de crédito</FinancesDataNoCredit>
                  ) : (
                    <FinancesDataNoCredit>Cliente no tiene creditos activos</FinancesDataNoCredit>
                  )
                )) : ''}
            </FinancesDataCreditCheckboxContainerLine>
            {!isLoading && creditsByAcesor.length ? (
              <SaldoTotalRecoger>
                <SaldoTotalRecogerContainer>Saldo total a recoger</SaldoTotalRecogerContainer>
                <SaldoTotalRecogerContainer>$ {formatPrice(parseInt(getListofCredits().reduce((accumulator, curr) => accumulator + curr.saldoAlDia, 0)) || 0)}</SaldoTotalRecogerContainer>
              </SaldoTotalRecoger>
            ) : ''}
          </FinancesDataCreditLine>
        ) : ''}
        {simulator.financesData.lineaCredito.idBackend === creditLinesBack[1].id ||
          simulator.financesData.lineaCredito.idBackend === creditLinesBack[3].id ? (
          <>
            <FinancesDataFieldTitle>Valores consolidación de deudas</FinancesDataFieldTitle>
            <FinancesDataFieldContainer>
              {simulator.financesData.fields.map((item, key) => (
                <FinancesDataFieldContent key={key}>
                  <FinancesDataFieldInputTitle>
                    <FinancesDataFieldTitleValorLabel>Valor {key + 1}</FinancesDataFieldTitleValorLabel>
                    {key > 0 && <FinancesDataFieldTitleValorDeleteItem onClick={() => deleteFieldFromStore(item)}>Eliminar Valor</FinancesDataFieldTitleValorDeleteItem>}
                  </FinancesDataFieldInputTitle>
                  <InputIntl
                    id={`chekbox${key}`}
                    key={key}
                    register={register}
                    onBlur={() => verifyFields()}
                    currencyConfig={currencyMoney}
                    name={`field${item.id}`}
                    defaultValue={item.value}
                    onChange={(event, value, maskedValue) => onChangeField(`field${item.id}`, key, value)}
                  />
                </FinancesDataFieldContent>
              ))}
            </FinancesDataFieldContainer>
          </>
        ) : ''}

        <ClientDataButtoCalculate align={simulator.financesData.lineaCredito.idBackend === creditLinesBack[1].id ||
          simulator.financesData.lineaCredito.idBackend === creditLinesBack[3].id}>
          {simulator.financesData.lineaCredito.idBackend === creditLinesBack[1].id ||
            simulator.financesData.lineaCredito.idBackend === creditLinesBack[3].id
            ? <ClientDataAddButton type="button" onClick={() => setSimulator({ type: SimulatorTypes.ADD_FIELD, field: { id: simulator.financesData.fields.length, value: '' } })} id="add-field">+ Añadir valor</ClientDataAddButton> : ''}
          <ClientDataButtoCalculateButton type="button" disabled={calculate} onClick={() => calculateData()} id="calculate">Calcular</ClientDataButtoCalculateButton>
        </ClientDataButtoCalculate>

        {showElement && !simulator.pricing && <>
          <ClientDataTotal>
            <ClientDataTotalTitle>Tasa E.A</ClientDataTotalTitle>
            <ClientDataTotalData>{formatTasa(valorTea)}</ClientDataTotalData>
          </ClientDataTotal>
          <ClientDataTotal>
            <ClientDataTotalTitle>DIA DE INTERESES INICIALES</ClientDataTotalTitle>
            <ClientDataTotalData>{simulator.simulation.diasInteresesIniciales}</ClientDataTotalData>
          </ClientDataTotal>
          <ClientDataTotal>
            <ClientDataTotalTitle>Capacidad aproximada</ClientDataTotalTitle>
            <ClientDataTotalData>$ {simulator.simulation.capacidadAproximada ? formatPrice(parseInt(simulator.simulation.capacidadAproximada)) : formatPrice(0)}</ClientDataTotalData>
          </ClientDataTotal>
          <ClientDataMontoTotal>
            <ClientDataTotalTitle>MONTO MÁXIMO SUGERIDO<b>*</b></ClientDataTotalTitle>
            <ClientDataTotalData>${formatPrice(parseInt(simulator.simulation.montoMaximoSugerido))}</ClientDataTotalData>
            <ClientDataTotalDataMin>Tasa: {simulator.priceValueToSolicitate.tasa?.nombre}</ClientDataTotalDataMin>
            <ClientDataTotalDataMinBlack>Plazo a {fields.plazo} Meses</ClientDataTotalDataMinBlack>
            <ClientDataTotalDataMinBlack><b>*</b> Los valores reflejados pueden variar dependiendo de la capacidad de endeudamiento, a la verificación de la documentación y políticas de crédito de la compañía.</ClientDataTotalDataMinBlack>
          </ClientDataMontoTotal>
          <FormFooterRigth>
            <SecondaryLargeButton col="flex-end" type="submit" id="submit">Continuar </SecondaryLargeButton>
          </FormFooterRigth>
        </>}

        {showElement && simulator.pricing && <>
          <FormRow col="2">
            <ClientDataTotal>
              <ClientDataTotalTitle>PERFIL DE RIESGO OPCIÓN 1
                <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-tasabaja' />
              </ClientDataTotalTitle>
            </ClientDataTotal>
            <ClientDataTotal>
              <ClientDataTotalTitle>PERFIL DE RIESGO OPCIÓN 2
                <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-tasaalta' />
              </ClientDataTotalTitle>
            </ClientDataTotal>
            <ClientDataTotal>
              <ClientDataTotalTitle>Tasa E.A</ClientDataTotalTitle>
              <ClientDataTotalData>{formatTasa(valorTea)}</ClientDataTotalData>
            </ClientDataTotal>
            <ClientDataTotal>
              <ClientDataTotalTitle>Tasa E.A</ClientDataTotalTitle>
              <ClientDataTotalData>{formatTasa(valorTea1)}</ClientDataTotalData>
            </ClientDataTotal>
            <ClientDataTotal>
              <ClientDataTotalTitle>DIA DE INTERESES INICIALES</ClientDataTotalTitle>
              <ClientDataTotalData>{simulator.simulation.diasInteresesIniciales}</ClientDataTotalData>
            </ClientDataTotal>
            <ClientDataTotal>
              <ClientDataTotalTitle>DIA DE INTERESES INICIALES</ClientDataTotalTitle>
              <ClientDataTotalData>{simulator.simulation1?.diasInteresesIniciales}</ClientDataTotalData>
            </ClientDataTotal>
            <ClientDataTotal>
              <ClientDataTotalTitle>Capacidad aproximada</ClientDataTotalTitle>
              <ClientDataTotalData>$ {simulator.simulation.capacidadAproximada ? formatPrice(parseInt(simulator.simulation.capacidadAproximada)) : formatPrice(0)}</ClientDataTotalData>
            </ClientDataTotal>
            <ClientDataTotal>
              <ClientDataTotalTitle>Capacidad aproximada</ClientDataTotalTitle>
              <ClientDataTotalData>$ {simulator.simulation1?.capacidadAproximada ? formatPrice(parseInt(simulator.simulation1?.capacidadAproximada)) : formatPrice(0)}</ClientDataTotalData>
            </ClientDataTotal>
            <ClientDataMontoTotal>
              <ClientDataTotalTitle>MONTO MÁXIMO SUGERIDO<b>*</b></ClientDataTotalTitle>
              <ClientDataTotalData>${formatPrice(parseInt(simulator.simulation.montoMaximoSugerido))}</ClientDataTotalData>
              <ClientDataTotalDataMin>Tasa NMV: {simulator.simulation.productPricing?.rate.toFixed(2)}%{/*simulator.priceValueToSolicitate.tasa?.nombre*/}</ClientDataTotalDataMin>
              <ClientDataTotalDataMinBlack>Plazo a {fields.plazo} Meses</ClientDataTotalDataMinBlack>
              <ClientDataTotalDataMinBlack><b>*</b> Los valores reflejados pueden variar dependiendo de la capacidad de endeudamiento, a la verificación de la documentación y políticas de crédito de la compañía.</ClientDataTotalDataMinBlack>
            </ClientDataMontoTotal>
            <ClientDataMontoTotal>
              <ClientDataTotalTitle>MONTO MÁXIMO SUGERIDO<b>*</b></ClientDataTotalTitle>
              <ClientDataTotalData>${formatPrice(parseInt(simulator.simulation1?.montoMaximoSugerido))}</ClientDataTotalData>
              <ClientDataTotalDataMin>Tasa NMV: {simulator.simulation1?.productPricing?.rate.toFixed(2)}%{/*simulator.priceValueToSolicitate.tasa?.nombre*/}</ClientDataTotalDataMin>
              <ClientDataTotalDataMinBlack>Plazo a {fields.plazo} Meses</ClientDataTotalDataMinBlack>
              <ClientDataTotalDataMinBlack><b>*</b> Los valores reflejados pueden variar dependiendo de la capacidad de endeudamiento, a la verificación de la documentación y políticas de crédito de la compañía.</ClientDataTotalDataMinBlack>
            </ClientDataMontoTotal>
          </FormRow>
          <FormFooterRigth>
            <SecondaryLargeButton col="flex-end" type="submit" id="submit">Continuar </SecondaryLargeButton>
          </FormFooterRigth>
          <Tooltip
            id='tooltip-tasaalta'
            effect="solid"
            place='top'
            border
            multiline
            textColor='#05443D'
            borderColor='#25BBAB'>
            <TooltipTitle>
              Opción 2
            </TooltipTitle>
            <TooltipContent>
              Perfil de riesgo negativo con la mejor tasa del grupo al que queda asignado.
            </TooltipContent>
          </Tooltip>
          <Tooltip
            id='tooltip-tasabaja'
            effect="solid"
            place='top'
            border
            multiline
            textColor='#05443D'
            borderColor='#25BBAB'>
            <TooltipTitle>
              Opción 1
            </TooltipTitle>
            <TooltipContent>
              Perfil de riesgo positivo con la mejor tasa del grupo al que queda asignado.
            </TooltipContent>
          </Tooltip>
        </>}

      </Form>


      <ModalInfo
        open={showModalInfoIngresos}
        setShowModal={setShowModalInfoIngresos}
        title={titleErrorIngresos}
        backgroundIcon={colors.bgDanger}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
      <ModalInfo
        open={showModalInfoError}
        setShowModal={modalErrorResetDefault}
        title={titleErrorOnCalculate}
        description={messageErrorOnCalculate}
        backgroundIcon={colors.bgDanger}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
      <ModalInfo
        open={showModalInfoProduct}
        setShowModal={setShowModalInfoProduct}
        title={titleErrorProduct}
        description={messageErrorProduct}
        backgroundIcon={colors.bgDanger}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
      <ModalInfo
        open={showModalNullContract}
        setShowModal={setShowModalNullContract}
        title='Es necesario seleccionar el tipo de contrato'
        backgroundIcon={colors.bgDanger}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
      {isLoading && <Loader />}

    </FormTemplate>

  )
}

export default OldPriceValueToSolicitatePage
